// function WorkInProgress({ onClose }) {
//   return (
//     <div style={styles.overlay}>
//       <div style={styles.box}>
//         <h2>🚧 Work in Progress</h2>
//         <p>
//           This section is currently under development.
//           <br />
//           We’re working hard to bring you the full UrbanDel experience.
//         </p>

//         <button onClick={onClose} style={styles.btn}>
//           Close
//         </button>
//       </div>
//     </div>
//   );
// }

// const styles = {
//   overlay: {
//     position: "fixed",
//     inset: 0,
//     background: "rgba(0,0,0,0.6)",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     zIndex: 200,
//   },
//   box: {
//     background: "#fff",
//     padding: "30px",
//     borderRadius: "10px",
//     textAlign: "center",
//     maxWidth: "350px",
//     width: "90%",
//   },
//   btn: {
//     marginTop: "15px",
//     padding: "8px 16px",
//     border: "none",
//     background: "#2563eb",
//     color: "#fff",
//     borderRadius: "6px",
//     cursor: "pointer",
//   },
// };

// export default WorkInProgress;

import "./WorkInProgress.css";

function WorkInProgress({ onClose }) {
  return (
    <div className="wip-overlay">
      <div className="wip-box">
        <h2>🚧 Work in Progress</h2>
        <p>
          This section is currently under development.
          <br />
          UrbanDel team is working on it.
        </p>

        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
}

export default WorkInProgress;
